/* b2s-size-cards.js — inject 4 size cards in Choose-My-Size + auto-select from ?variant=XXX */
(function(){
  'use strict';
  /* label comes from a locale string injected by Liquid (window.B2S_I18N) so the translation plugin handles it — no hardcoded translations */
  var B2S_SC_LABEL = (window.B2S_I18N && window.B2S_I18N.selectSize) || 'Select your size';
  const SIZES = [
    { label: 'S',  color: '#6BAED6' },
    { label: 'M',  color: '#74C476' },
    { label: 'L',  color: '#FD8D3C' },
    { label: 'XL', color: '#C44E52' }
  ];

  /* Variant ID -> size mapping. Includes nasal-stent-back2sleep + draft snorekit. */
  const VARIANT_TO_SIZE = {
    "41431140794551": "S",
    "41431140827319": "M",
    "41431140860087": "L",
    "41431140892855": "XL",
    "53088887112027": "S",
    "53096520188251": "M",
    "53096520221019": "L",
    "53096520253787": "XL"
  };

  function getSizeFromURL() {
    try {
      const url = new URL(window.location.href);
      const variantId = url.searchParams.get('variant');
      if (variantId && VARIANT_TO_SIZE[variantId]) return VARIANT_TO_SIZE[variantId];
    } catch(e) {}
    return null;
  }

  function setStyle(el, prop, val) { el.style.setProperty(prop, val, 'important'); }

  function applyCardStyles(btn, isSelected) {
    if (isSelected) {
      setStyle(btn, 'background', '#1c2540');
      setStyle(btn, 'color', '#f4ecdb');
      setStyle(btn, '-webkit-text-fill-color', '#f4ecdb');
      setStyle(btn, 'border-color', '#1c2540');
      setStyle(btn, 'box-shadow', '0 14px 28px -10px rgba(28,37,64,0.4)');
      setStyle(btn, 'transform', 'translateY(-1px)');
    } else {
      setStyle(btn, 'background', '#ffffff');
      setStyle(btn, 'color', '#1c2540');
      setStyle(btn, '-webkit-text-fill-color', '#1c2540');
      setStyle(btn, 'border-color', 'rgba(28,37,64,0.12)');
      setStyle(btn, 'box-shadow', 'none');
      setStyle(btn, 'transform', 'none');
    }
    const lbl = btn.querySelector('.b2s-size-card__label');
    if (lbl) {
      setStyle(lbl, 'color', isSelected ? '#f4ecdb' : '#1c2540');
      setStyle(lbl, '-webkit-text-fill-color', isSelected ? '#f4ecdb' : '#1c2540');
      setStyle(lbl, 'font-weight', '700');
      setStyle(lbl, 'font-size', '17px');
    }
  }

  function selectCard(wrap, size) {
    const btn = wrap.querySelector('.b2s-size-card[data-size="' + size + '"]');
    if (!btn) return;
    wrap.querySelectorAll('.b2s-size-card').forEach(b => {
      b.classList.remove('is-selected');
      applyCardStyles(b, false);
    });
    btn.classList.add('is-selected');
    applyCardStyles(btn, true);
  }

  function injectSizeCards(){
    const chooseBlock = document.querySelector('[class*="lumin_quantity_break_rdqCtM"] .lumin-product-block-qty-break-variants');
    if (!chooseBlock) return;
    if (chooseBlock.dataset.b2sSizeCardsInjected === '1') return;

    const oldSelect = chooseBlock.querySelector('select');
    if (oldSelect) oldSelect.style.display = 'none';
    const oldTitle = chooseBlock.querySelector('.lumin-product-block-qty-break-variant-title');
    if (oldTitle) oldTitle.style.display = 'none';
    const oldOptLabel = chooseBlock.querySelector('.lumin-option-label');
    if (oldOptLabel) oldOptLabel.style.display = 'none';

    const wrap = document.createElement('div');
    wrap.className = 'b2s-size-cards';
    wrap.innerHTML = '<div class="b2s-size-cards__label" style="font-size:12px;font-weight:600;letter-spacing:0.12em;text-transform:uppercase;color:#f4ecdb;opacity:0.85;margin-bottom:10px">' + B2S_SC_LABEL + '</div>'
      + '<div class="b2s-size-cards__row" style="display:flex;flex-direction:row;gap:10px;flex-wrap:nowrap"></div>';

    const row = wrap.querySelector('.b2s-size-cards__row');
    SIZES.forEach(s => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'b2s-size-card';
      btn.dataset.size = s.label;
      btn.style.cssText = 'flex:1 1 0;min-width:0;padding:14px 8px;border-radius:10px;border:2px solid rgba(28,37,64,0.12);border-left:4px solid ' + s.color + ';cursor:pointer;transition:all 0.22s ease;display:flex;align-items:center;justify-content:center;min-height:56px;font-family:inherit';
      btn.innerHTML = '<span class="b2s-size-card__label" style="font-weight:700;letter-spacing:0.04em;font-size:17px">' + s.label + '</span>';
      applyCardStyles(btn, false);
      row.appendChild(btn);
    });

    chooseBlock.appendChild(wrap);

    wrap.addEventListener('click', function(e){
      const btn = e.target.closest('.b2s-size-card');
      if (!btn) return;
      selectCard(wrap, btn.dataset.size);
      const chooseRadio = document.querySelector('[class*="lumin_quantity_break_rdqCtM"] input[type="radio"]');
      if (chooseRadio && !chooseRadio.checked) chooseRadio.click();
      window.dispatchEvent(new CustomEvent('b2s:size-selected', { detail: { size: btn.dataset.size } }));
    });

    chooseBlock.dataset.b2sSizeCardsInjected = '1';

    const urlSize = getSizeFromURL();
    if (urlSize) {
      selectCard(wrap, urlSize);
      const chooseRadio = document.querySelector('[class*="lumin_quantity_break_rdqCtM"] input[type="radio"]');
      if (chooseRadio && !chooseRadio.checked) chooseRadio.click();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectSizeCards);
  } else {
    injectSizeCards();
  }

  document.addEventListener('change', function(e){
    if (e.target && e.target.matches('input[type="radio"][name*="qty-break"]')) {
      setTimeout(injectSizeCards, 200);
    }
  });

  const observer = new MutationObserver(() => injectSizeCards());
  const target = document.querySelector('main');
  if (target) observer.observe(target, { childList: true, subtree: true });
})();
